import NotificationApi from '@apis/notification/NotificationApi';
import queries from '@apis/queries';
import useLoading from '@hooks/ui/useLoading';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSetAtom } from 'jotai';

import { notificationsAtom } from '../../../atoms/notificationAtoms';

function useReadAllNotifications() {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { startLoading, stopLoading } = useLoading();
  const setNotifications = useSetAtom(notificationsAtom);
  const { mutate } = useMutation({
    mutationFn: NotificationApi.readAll,
    onMutate() {
      startLoading();
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: queries.notifications._def });
      setNotifications((prev) => prev.map((notification) => ({
        ...notification,
        readAt: new Date(),
      })));
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '오류가 발생하였습니다.');
    },
    onSettled() {
      stopLoading();
    },
  });
  return () => { mutate(); };
}

export default useReadAllNotifications;
